import { useSelector } from 'react-redux';
import { useSocketSubscribe } from 'packages/socket';
// Not from the barrel: it re-exports the designs-thumbnails ThumbnailWSData, not this one.
import { subscribeAssetsStatusOptions, type ThumbnailWSData } from 'packages/socket/subscribeOptions/assetsStatus';
import { useSseSubscribe, useIsSseEnabled, sseAssetsStatusOptions } from 'packages/sse';
import { customerIdSelector } from 'packages/store/user/user.selectors';

type Params = {
    assetIds: string[];
    onMessage: (data: { items: ThumbnailWSData[] }, unsubscribe: () => void) => void;
};

/**
 * Picks the asset-status transport for the flag. Shared, because this subscription has two
 * consumers and the branch would otherwise be duplicated.
 */
export default function useAssetStatusSubscribe({ assetIds, onMessage }: Params) {
    const customerId = useSelector(customerIdSelector);
    const isSseEnabled = useIsSseEnabled();

    // Both are called every render; only the selected one is ever invoked. Neither opens a
    // connection at call time, so the unused one costs nothing.
    const subscribeViaSocket = useSocketSubscribe(subscribeAssetsStatusOptions({ customerId, assetIds, onMessage }));
    const subscribeViaSse = useSseSubscribe(sseAssetsStatusOptions({ assetIds, onMessage }));

    return isSseEnabled ? subscribeViaSse : subscribeViaSocket;
}
